
import { useEffect } from 'react';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const MySwal = withReactContent(Swal);

const MessageDialog = (props) => {

    useEffect(() => {

        const showDialog = async () => {

            await MySwal.fire({
                title: props.header || 'Mensagem',

                html: <div>{props.message}</div>,

                icon: ['danger', 'warning'].includes(props.variant)
                    ? 'warning'
                    : props.variant === 'success'
                        ? 'success'
                        : props.variant === 'info'
                            ? 'info'
                            : 'question',

                confirmButtonText: props.buttonText || 'OK',
                confirmButtonColor: '#0d6efd',

                showCancelButton: false,
                showConfirmButton: true,

                allowOutsideClick: true,
                allowEscapeKey: true,

                focusConfirm: true
            });

            props.onClose?.();
        };

        showDialog();

        return () => {
            MySwal.close();
        };

    }, []);

    return null;
};

export default MessageDialog;
